import uuidv1 from 'uuid/v1';

const ID_PREFIX = 'UMS_';

export const getId = () => uuidv1();
export const getNewChildId = () => ID_PREFIX + getId();
